
<template>
  <b-card no-body class="order-card">
    <b-card-header header-tag="header" role="tab" class="order-card__header" @click.prevent="goToOrder">
      <div class="order-card__header-block block-order-id">
        <span class="text">{{order.increment_id}}</span>
      </div>
      <div class="order-card__header-block block-shipping">
        <span class="text">{{order.shipping_description}}</span>
      </div>
      <div class="order-card__header-block block-fullname">
        <span class="text">{{fullName}}</span>
      </div>
      <div class="order-card__header-block block-telephone">
        <span class="text">{{phoneNumber}}</span>
      </div>
      <div class="order-card__header-block block-qty-ordered">
        <span class="text">{{ order.total_qty_ordered }}</span>
      </div>
      <div class="order-card__header-block block-status">
        <div class="order-badge-status" :class="[`order-status-${order.status}`]"></div>
        <span class="text">{{ $t(`order-status.${order.status}`) }}</span>
      </div>
      <div class="order-card__header-block block-seller">
        <span class="text">{{ order.seller }}</span>
      </div>
      <div class="order-card__header-block block-creation">
        <span class="text">{{ createdAt }}</span>
      </div>
      <div class="order-card__header-block block-contact">
        <a :href="'mailto:'+order.customer_email" class="bcm-link">
          <svg class="o-icon"><use xlink:href="#email-outline"></use></svg>
        </a>
      </div>
    </b-card-header>
  </b-card>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isCollapsed: false
    }
  },
  computed: {
    fullName () {
      if (this.order.customer_fullname) {
        return this.order.customer_fullname
      } else {
        return this.$t('not-specified')
      }
    },
    phoneNumber () {
      if (this.order && Object.keys(this.order.billing_address).length > 0) {
        return this.order.billing_address.telephone || this.$t('not-specified')
      } else {
        return this.$t('not-specified')
      }
    },
    createdAt () {
      return dayjs(this.order.created_at).format('DD/MM/YYYY')
    }
  },
  methods: {
    goToOrder () {
      this.$store.commit('orders/setOrder', {})
      this.$router.push({
        name: 'myOrder',
        params: { id: this.order.entity_id }
      })
    }
  }
}
</script>
